import React from "react";

export default function Footer() {
  return (
    <footer>
      This project was coded by Deepa Saha and is{" "}
      <a
        href="https://github.com/deepasaha01/react-weather-app"
        target="_blank"
        rel="noreferrer"
      >
        open-sourced on GitHub
      </a>{" "}
      and{" "}
      <a
        href="https://dreamy-pike-c89999.netlify.app"
        target="_blank"
        rel="noreferrer"
      >
        hosted on Netlify.
      </a>
    </footer>
  );
}
